import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, IconButton } from '@material-ui/core';
import useStylesCommon from '../common/AdditionalDetailsCommonStyles';
import i18nNamespaces from '../../../../const/i18nNamespaces';
import { useTranslation } from 'react-i18next';
import { GetApp } from '@material-ui/icons';
import referralsProvider from '../../../../services/referralsProvider';
import filesDownloadProvider from '../../../../services/filesDownloadProvider';
import axios from 'axios';
import Loading from '../../../common/Loading/Loading';
import { AlertContext } from '../../../../contexts/AlertContext';
import { PatientReferralInAppointment } from '../../../../types/appointments';
import { getPreparedLang, isNotNullOrUndefined } from '../../../../utils/lang';
import { getTranslation } from '../../../../utils/translation';

type PatientReferralsListProps = {
    referrals?: PatientReferralInAppointment[];
};

const useStyles = makeStyles((theme) => ({
	orderItem: {
        marginTop: 20,
        marginBottom: 20,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    orderDetails: {
        display: 'flex',
        flexDirection: 'column',

    }
}));

const PatientReferralsList = ({ referrals }: PatientReferralsListProps) => {
    const classesCommon = useStylesCommon();
	const classes = useStyles();
    const {t, i18n} = useTranslation(i18nNamespaces.APPOINTMENT_DETAILS);
    const {t: tCommon} = useTranslation(i18nNamespaces.COMMON);
    const {t: tErrors} = useTranslation(i18nNamespaces.ERRORS);
    const [loading, setLoading] = React.useState(false);
    const openAlert = useContext(AlertContext);
    const currentLanguage = getPreparedLang(i18n.language);
    
    const handleDownloadPdf = async (id: number) =>{
        try{
            setLoading(true);
            const url = (await referralsProvider.getReferralPdfUrl(id)).data;
            if(url!==null){
                filesDownloadProvider.downloadFileFromUrl(
                    url,
                    tCommon('referral')+".pdf"
                );
            }
        } catch(error){
            if (axios.isAxiosError(error) &&
                error.response.status === 404)
                openAlert({
                    severity: 'error',
                    message: tCommon('fileNotGenerated'),
                });
            else
                openAlert({
                    severity: 'error',
                    message: tErrors('downloadReferralError'),
                });
            console.error(error);
        } finally{
            setLoading(false);
        }
    }


	return (
        <Box style={{marginBottom: 20, marginTop: 20}}>
            <Loading loading={loading} withBackdrop />
            <h4 className={`${classesCommon.detailsHeader}`}>
                {t('referrals')}
            </h4>
            {referrals && referrals.length > 0 ? (
                referrals.map(referral => (
                    <Box key={referral.id} className={classes.orderItem}>
                        <Box className={classes.orderDetails}>
                            <Box>
                                {getTranslation(referral.medicalService.name, 
                                    referral.medicalService.translations, currentLanguage, "name")}
                            </Box>
                        </Box>
                        <Box>
                            {referral.availableInPdfForm && (
                                <IconButton
                                    size={'small'}
                                    style={{marginLeft: 10}}
                                    onClick={() => handleDownloadPdf(referral.id)}
                                >
                                    <GetApp fontSize={'small'} color={'secondary'}/>
                                </IconButton>
                            )}
                        </Box>
                    </Box>
                ))
            ) : (
                <p>{t('noReferrals')}</p>
            )}
        </Box>
	);
};

export default PatientReferralsList;
